import React, { useContext, useEffect, useState } from 'react'
import { getImages } from '../../const'
import Header from '../Component/Common/Header'
import UseScrollReveal from '../Component/Common/UseScrollReveal'
import { TripContext } from '../Context/TripContext'
import { useNavigate } from 'react-router-dom'

const Landing = () => {

    const navigate = useNavigate();

    const {tripData,generateTrip, tripLoading} = useContext(TripContext);

    const [tripInputData,setTripInputData] = useState({prompt:"plan a road trip from austin to utah"});

    const updateTripData = (e) => {
        setTripInputData({...tripInputData,[e.target.name]:e.target.value});
    }

    const tripSubmit = (e) => {
        e.preventDefault();

        console.log(tripInputData);

        generateTrip(tripInputData);
    }

    useEffect(() => {
        if (Object.keys(tripData).length) {
            navigate("/trip-map", { replace: true });
        }
    }, [tripData]);
    UseScrollReveal();

    return (
        <>
            <div className='landing-page'>
                <Header />
                <div className='landing-block'>
                    <div className='d-flex align-items-center h-100vh'>
                        <div className='w-100'>
                            <div className='lg-title mb-2 add-start-before wow reveal fadeInUp'>Your Roadtrip Copilot</div>
                            <p className='wow reveal fadeInUp'>Describe the trip you’d like, and we’ll create the multi-stop route.</p>
                            <form className='custom-form mt-4' onSubmit={tripSubmit}>
                                <div className='position-relative wow reveal fadeIn'>
                                    <textarea className='form-control h170' placeholder='Ex: 7 days from Los Angeles. National parks. Scenic drives. Easy hikes. Good coffee.' name="prompt" onChange={updateTripData} value={tripInputData?.prompt}></textarea>
                                    <button className='btn text-center common-btn start-trip-btn position-absolute align-items-center d-inline-flex justify-content-center' type='submit'>
                                        {!tripLoading ? 
                                            <>
                                                <img className='pe-1' src={getImages('send-icon.png')} />
                                                <div className='pe-2'>Start Trip</div>
                                            </> :
                                            <>
                                                <div className="spinner-border" role="status">
                                                    <span className="visually-hidden"></span>
                                                </div>
                                                <div className='ms-2'>Loading</div>
                                            </>
                                        }
                                    </button>
                                </div>
                                <div className='landing-btn-actions mt-4 wow reveal fadeInUp'>
                                    <div className='d-flex align-items-center flex-wrap justify-content-sm-between'>
                                        <div className='me-2'>
                                            <button className='btn common-btn btn-dark-bg mnw-120' type='button'>Solo Trip</button>
                                        </div>
                                        <div className='me-2'>
                                            <button className='btn common-btn btn-dark-bg mnw-120' type='button'>Couples</button>
                                        </div>
                                        <div className='me-2'>
                                            <button className='btn common-btn btn-dark-bg mnw-120' type='button'>Families</button>
                                        </div>
                                        <div className='me-2'>
                                            <button className='btn common-btn btn-dark-bg mnw-120' type='button'>Van life</button>
                                        </div>
                                        <div>
                                            <button className='btn common-btn btn-dark-bg mnw-120' type='button'>Weekend Warriors</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Landing